import styled from 'styled-components'
import type { ButtonsContainer } from '../utils'

export const Buttons = (props: ButtonsContainer) => {
	if (props.primary.visible === false && props.secondary.visible === false) return null

	return (
		<ButtonsStyled {...props}>
			{props.primary.visible && <button className="primary">{props.primary.text}</button>}
			{props.secondary.visible && <button className="secondary">{props.secondary.text}</button>}
		</ButtonsStyled>
	)
}

const ButtonsStyled = styled.div<ButtonsContainer>`
	width: 100%;
	display: flex;
	gap: 2ch;
	justify-content: ${({ container }) => {
		if (container.placement === 'left') return 'flex-start'
		if (container.placement === 'right') return 'flex-end'
		return 'center'
	}};

	button {
		padding: 0.8em 1.6em;
		border-radius: 5px;
		font-family: 'Montserrat Variable', sans-serif;
	}

	button.primary {
		color: ${({ primary }) => primary.textColor};

		background-color: ${({ primary }) => {
			if (primary.design === 'default') {
				return primary.backgroundColor
			}

			return 'transparent'
		}};

		border: ${({ primary }) => {
			if (primary.design === 'simple') {
				return '1px solid ' + primary.backgroundColor
			}

			return 'none'
		}};
	}

	button.secondary {
		color: ${({ secondary }) => secondary.textColor};

		background-color: ${({ secondary }) => {
			if (secondary.design === 'default') {
				return secondary.backgroundColor
			}

			return 'transparent'
		}};

		border: ${({ secondary }) => {
			if (secondary.design === 'simple') {
				return '1px solid ' + secondary.backgroundColor
			}

			return 'none'
		}};
	}
`
